import { __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { ButtonMobile } from '../../../../button/esm/mobile';
import { os } from '../../../../shared/esm';

var styles = {"button":"pass-code__button_crg97","secondary":"pass-code__secondary_crg97","isIOS":"pass-code__isIOS_crg97"};
require('./index.css');

function KeyPadButton(_a) {
    var _b;
    var children = _a.children, onClick = _a.onClick, _c = _a.view, view = _c === void 0 ? 'secondary' : _c, buttonClassName = _a.buttonClassName, dataTestId = _a.dataTestId, title = _a.title;
    return (React.createElement(ButtonMobile, __assign({ className: cn(styles.button, styles[view], buttonClassName, (_b = {},
            _b[styles.isIOS] = os.isIOS(),
            _b)), view: view, onClick: function () { return onClick === null || onClick === void 0 ? void 0 : onClick(children); }, dataTestId: dataTestId }, (title && { title: title })), children));
}

export { KeyPadButton };
